import { FC, useRef, useState } from 'react';
import { t } from 'i18next';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { setSelectedRowDensity } from '../../../../store/slice/config/config';
import { RowDensity } from '../../../../enum/RowDensity';
import rowDensityIcon from '../../../../assets/img/png/health-monitor/row-density-icon.png';
import dropdownArrow from '../../../../assets/img/png/health-monitor/rows-per-page-dropdown.png';
import normalDensity from '../../../../assets/img/png/health-monitor/normal.png';
import smallDensity from '../../../../assets/img/png/health-monitor/small.png';
import extraSmallDensity from '../../../../assets/img/png/health-monitor/extra-small.png';
import { useOutsideFocus } from '../../../../hook/useOutsideFocus';
import { updateApplicationConfig } from '../../../../util/update-config';

const rowDensities = [
  {
    density: RowDensity.NORMAL,
    icon: normalDensity,
  },
  {
    density: RowDensity.SMALL,
    icon: smallDensity,
  },
  {
    density: RowDensity.EXTRA_SMALL,
    icon: extraSmallDensity,
  },
];

const RowDensityMenu: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedRowDensity = useAppSelector((state) => state.configSlice.selectedRowDensity);
  const menuRef = useRef<HTMLUListElement>(null);
  const dispatch = useAppDispatch();

  useOutsideFocus(
  isOpen,
  () => setIsOpen(false),
  menuRef
);

  const translateRowDensityName = (rowDensity: RowDensity): string => {
    let resultingRowDensityName = '';

    switch (rowDensity) {
      case RowDensity.SMALL:
        resultingRowDensityName = 'Small';
        break;

      case RowDensity.EXTRA_SMALL:
        resultingRowDensityName = 'X-Small';
        break;

      default:
        resultingRowDensityName = 'Normal';
        break;
    }

    return resultingRowDensityName;
  };

  return (
    <span
      data-pw="rowdensity"
      ref={menuRef}
      className="row_density"
      onClick={() => setIsOpen((prevState) => !prevState)}
    >
      <img src={rowDensityIcon} alt="rowDensityDropdown"></img>
      {t('healthMonitor.footer.pagination.rowDensity')} <span>{translateRowDensityName(selectedRowDensity)}</span>
      <ul className={`menu ${isOpen ? 'open' : ''}`}>
        {rowDensities.map((rowDensity, index) => (
          <li
            key={`${rowDensity}-${index}`}
            style={{ backgroundImage: `url(${rowDensity.icon})` }}
            onClick={() => {
              dispatch(setSelectedRowDensity(rowDensity.density));
              updateApplicationConfig({ rowDensity: rowDensity.density }, dispatch);
            }}
          >
            {translateRowDensityName(rowDensity.density)}
          </li>
        ))}
      </ul>
      <img className={`arrow_icon ${isOpen ? 'rotated' : ''}`} src={dropdownArrow} alt="dropdownArrow"></img>
    </span>
  );
};

export default RowDensityMenu;
